import { Button } from "@/src/components/ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTrigger } from "@/src/components/ui/dialog";
import { Separator } from "@/src/components/ui/separator";
import { useToast } from "@/src/components/ui/use-toast";
import { formatDateUTC } from "@/src/helpers/formatDateUTC";
import { useBookingPaymentLogsDataQuery } from "@/src/lib/bookingPaymentLogs";
import { useRemoveBookingPaymentMutation } from "@/src/lib/bookingRemovePaymentMutation";
import React, { useEffect, useState } from "react";

interface BookingPaymentLogsProps {
  paymentId: string;
  bookingId: string;
}

const BookingPaymentLogs: React.FC<BookingPaymentLogsProps> = ({ paymentId, bookingId }) => {
  const [open, setOpen] = useState(false);
  const { toast } = useToast();
  const removePaymentMutation = useRemoveBookingPaymentMutation(paymentId, bookingId);
  const {
    data: logsData,
    isLoading: isLoadingLogsData,
    refetch,
  } = useBookingPaymentLogsDataQuery(paymentId, bookingId, { enabled: false });

  useEffect(() => {
    if (open && paymentId && bookingId) {
      refetch();
    }
  }, [open, paymentId, bookingId, refetch]);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <p className="text-sm text-yellow-500 font-medium cursor-pointer ml-auto pl-2 pt-4 pb-4">Logs</p>
      </DialogTrigger>
      <DialogContent
        className="max-w-3xl"
        style={{
          maxHeight: "90vh",
          overflowY: "auto",
        }}
      >
        {" "}
        <DialogHeader>
          <h2 className="text-2xl">Action logs</h2>
        </DialogHeader>
        <div className="flex flex-col gap-y-4 mt-4">
          {logsData && logsData?.data?.length ? (
            logsData.data.map((log, index) => (
              <>
                <div key={index} className="flex">
                  <p className="text-sm text-gray-900">
                    <span className="font-medium">
                      {log.userName} {log.userEmail ? `(${log.userEmail})` : ""}
                    </span>{" "}
                    {log.comment || "No comment provided."}
                  </p>
                  <p className="text-sm text-slate-700 ml-auto">
                    {formatDateUTC(log.timestamp, "UTC", undefined, undefined, undefined, true)}
                  </p>
                </div>
                {index !== logsData.data.length - 1 && <Separator />}
              </>
            ))
          ) : (
            <p className="text-sm text-muted-foreground">No logs available for this payment.</p>
          )}
        </div>
        <div className="-mx-6 mt-2 mb-2">
          <hr className="border-t border-gray-200 w-full" />
        </div>
        <DialogFooter>
          <Button onClick={() => setOpen(false)}>Close</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default BookingPaymentLogs;
